import { MeshLoadCancelledError } from '@/plugins/mesh/errors'
import type { GltfTaskScheduler } from '@/plugins/mesh/loaders/gltfLowMemory/interfaces'
import type { GltfTaskYieldOptions } from '@/plugins/mesh/types'

function throwIfCancelled(signal: AbortSignal | undefined): void {
  if (signal?.aborted) {
    throw new MeshLoadCancelledError('(glTF 任务调度)', { cause: signal.reason })
  }
}

/** 通过 setTimeout 进入下一个宏任务，确保浏览器有机会处理渲染和输入。 */
export class MacrotaskGltfScheduler implements GltfTaskScheduler {
  async yield(signal?: AbortSignal): Promise<void> {
    throwIfCancelled(signal)
    await new Promise<void>((resolve) => setTimeout(resolve, 0))
    throwIfCancelled(signal)
  }
}

/** 复用字节和顶点配额的轻量让步控制器。 */
export class GltfYieldController {
  private bytes = 0
  private vertices = 0

  constructor(
    private readonly scheduler: GltfTaskScheduler,
    private readonly options: GltfTaskYieldOptions
  ) {}

  consume(bytes: number, vertices: number, signal?: AbortSignal): Promise<void> | undefined {
    throwIfCancelled(signal)
    this.bytes += bytes
    this.vertices += vertices
    if (
      this.bytes < this.options.maxBytesPerTask &&
      this.vertices < this.options.maxVerticesPerTask
    ) {
      return undefined
    }
    this.bytes = 0
    this.vertices = 0
    return this.scheduler.yield(signal)
  }
}
